import {  Component, ElementRef, Input,  ViewChild, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {VariantType} from "../../../model/enums/VariantType.enum";
import {ProductDimensions, ProductVariants} from "../../../model/view/Product";
import KeenSlider, {KeenSliderInstance} from "keen-slider"

@Component({
  selector: 'v-product-variants',
  templateUrl: './product-variants.component.html',
  styleUrls: [
    '../../../../../../node_modules/keen-slider/keen-slider.css',
    './product-variants.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductVariantsComponent {
  @Input() code;
  @Input() variants: (ProductVariants|ProductDimensions)[];
  @Input() type;
  @Output() loadProduct: EventEmitter<string> = new EventEmitter();
  variantsType = VariantType;
  active = false;
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>
  currentSlide: number = 0
  slider: KeenSliderInstance = null

  constructor(private cd: ChangeDetectorRef) {
  }

  changeVariant(code) {
    this.code !== code && this.loadProduct.emit(code);
  }

  title(type) {
    switch (type) {
      case VariantType.COLOUR:
        return 'productDetails.variant.colorus';
        break;
      case VariantType.DIMENSIONS:
        return 'productDetails.variant.dimensions';
        break;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if(this.type === VariantType.COLOUR ){
          let initialKeenSlide = 0;
          const selectedIndex = this.variants.map(e => e.selected).indexOf(true);
          if(selectedIndex > 1){
            initialKeenSlide = Math.floor(selectedIndex/5);
          }
          this.slider = new KeenSlider(this.sliderRef.nativeElement, {
            initial: initialKeenSlide,
            slides: {
              perView: 5,
              spacing: 0,
            },
            slideChanged: (s) => {
              this.cd.markForCheck();
            },
          })
      }
      this.cd.markForCheck();
    });
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy()
  }
}
